import { Component, Input, OnInit } from '@angular/core';
import {
  CustomerService,
  OrganisationsService,
  SupplierService,
  UserService,
} from '../../../services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OrganisationTypeEnum } from '../../../enums/organisation-types';
import { IOrganisationActivationData } from '../../../interfaces/organisation-activation-data.interface';
import { ICustomer } from '../../../interfaces/customer';
import { IUser } from '../../../interfaces/user';
import { SelectItem } from 'primeng';
import { IUpdateOrgActivityStatus } from '../../../interfaces/update-org-activity-status.interface';

@Component({
  selector: 'app-organisation-activation-control',
  templateUrl: 'organisation-activation-control.component.html',
  styleUrls: ['organisation-activation-control.component.scss'],
})
export class OrganisationActivationControlComponent implements OnInit {
  constructor(
    private organisationService: OrganisationsService,
    private messageService: MessageService,
    private userService: UserService,
    private supplierService: SupplierService,
    private customerService: CustomerService,
    private confirmationService: ConfirmationService,
  ) {}

  private _organisationId: number;
  @Input() set organisationId(value: number) {
    this._organisationId = value;

    if (this._organisationId) {
      this.loadActivationData();
    }
  }
  get organisationId(): number {
    return this._organisationId;
  }

  // activation summary data for UI
  activationData: IOrganisationActivationData;

  // actual customer data
  @Input() customerData: ICustomer;

  showActiveStateChangeDialog: boolean = false;
  showSuspensionDialog: boolean = false;
  isSubmitting: boolean = false;

  changeActivityItem: any = {};
  isVmeMode: boolean;
  currentUser: IUser;

  deactivationReasons: any[];
  deactivationReasonsItems: SelectItem[];

  suspensionReasons: any[];
  suspensionReasonsItems: SelectItem[];

  ngOnInit() {
    this.userService.getCurrentUserOrg().then((res) => {
      this.isVmeMode = res.organisationTypeId == 1;
    });

    this.userService.getLoggedUser().then((res) => (this.currentUser = res));

    this.supplierService.getDeactivationReasons().then((result) => {
      console.log('Deactivation reasons: ', result);

      this.deactivationReasons = result;

      this.deactivationReasonsItems = result.map((x) => {
        return <SelectItem>{ label: x.reasonDescription, value: x.id };
      });
    });

    this.supplierService.getSuspensionReasons().then((result) => {
      console.log('Suspension reasons: ', result);

      this.suspensionReasons = result;

      this.suspensionReasonsItems = result.map((x) => {
        return <SelectItem>{ label: x.reasonDescription, value: x.id };
      });
    });
  }

  loadActivationData() {
    this.organisationService.getActivationData(this.organisationId).then((res) => {
      console.log('Activation data: ', res);
      this.activationData = res;
    });
  }

  setChangeActivityUser() {
    this.userService.getLoggedUser().then((res) => {
      this.changeActivityItem.userName = res.email;
    });
  }

  suspendAccount() {
    this.changeActivityItem = {};
    this.showSuspensionDialog = true;
    this.changeActivityItem.isSuspension = true;

    this.setChangeActivityUser();
  }

  deactivateAccount() {
    this.changeActivityItem = {};
    this.showActiveStateChangeDialog = true;
    this.changeActivityItem.isActivation = false;

    this.setChangeActivityUser();
  }

  activateAccount() {
    this.changeActivityItem = {};
    this.showActiveStateChangeDialog = true;
    this.changeActivityItem.isActivation = true;

    this.setChangeActivityUser();
  }

  get selectedReasonSendsSurvey(): boolean {
    if (this.customerData?.organisationTypeId !== OrganisationTypeEnum.Supplier) {
      return false;
    }

    return (
      this.deactivationReasons?.find((x) => x.id === this.changeActivityItem.deactivationReasonId)
        ?.sendExitSurvey === true
    );
  }

  onDeactivateClicked() {
    if (this.changeActivityItem.isActivation || !this.selectedReasonSendsSurvey) {
      this.confirmChangeActivityStatus();
      return;
    }

    this.confirmationService.confirm({
      header: 'Deactivation Survey',
      message:
        'This deactivation reason will send a deactivation survey to the supplier. Do you want to continue?',
      icon: 'pi pi-exclamation-triangle',
      key: 'deactivation-survey-warning',
      accept: () => this.confirmChangeActivityStatus(),
      reject: () => {},
    });
  }

  confirmChangeActivityStatus() {
    const dto = {
      orgId: this.organisationId,
      reason: this.changeActivityItem.isSuspension
        ? this.changeActivityItem.suspensionReasonText
        : this.changeActivityItem.reason,
      suspend: this.changeActivityItem.isSuspension,
      deactivate: !this.changeActivityItem.isActivation && !this.changeActivityItem.isSuspension,
      deactivationReasonId: this.changeActivityItem.deactivationReasonId,
      suspensionReasonId: this.changeActivityItem.suspensionReasonId,
    } as IUpdateOrgActivityStatus;

    this.isSubmitting = true;

    this.customerService.updateActivityStatus(dto).then(
      (res) => {
        this.isSubmitting = false;
        this.showActiveStateChangeDialog = false;
        this.showSuspensionDialog = false;

        this.loadActivationData();
      },
      // Leave the dialog open on failure so the entered reason is not lost.
      () => {
        this.isSubmitting = false;
      },
    );
  }
}
